import { render, staticRenderFns } from "./NewsHeader.vue?vue&type=template&id=69fa0d67&scoped=true&"
import script from "./NewsHeader.vue?vue&type=script&lang=ts&"
export * from "./NewsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NewsHeader.vue?vue&type=style&index=0&id=69fa0d67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fa0d67",
  null
  
)

export default component.exports